import { makeStyles } from "@material-ui/core/styles";
import { FONTS } from "../../../../../emotion-theme";

export const useTabsPanelStyles = makeStyles(() => ({
  panel: {
    fontFamily: FONTS.primary,
    height: "100%",
    margin: "2rem 0",
    position: "relative",
  },
}));
